import { useContext } from "react";

import { UnreadNotificationsContext } from "../../contexts/UnreadNotificationsContext";

export const useUnreadNotifications = () => {
  return useContext(UnreadNotificationsContext);
};